<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { getImageUrl } from '../utility';
import { useFilterStore } from '@Portal/stores/filter';

defineProps<{
  hasNoData?: boolean;
}>();
const filterStore = useFilterStore();
const { dateFilterDisplayValue } = storeToRefs(filterStore);
</script>
<template>
  <!-- Skeleton -->
  <div class="stretch-height skeleton" v-if="!hasNoData">
    <svg width="554" height="242" viewBox="0 0 554 242" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="553.34" height="242" rx="3" fill="white" />
      <mask
        id="mask0_3802_5489"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="554"
        height="242"
      >
        <path
          d="M0 3C0 1.34315 1.34315 0 3 0H550.34C551.997 0 553.34 1.34315 553.34 3V239C553.34 240.657 551.997 242 550.34 242H3.00001C1.34316 242 0 240.657 0 239V3Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3802_5489)">
        <path
          d="M-6.52344 173.529C-6.52344 173.529 163.161 226.809 360.122 191.719C632.389 143.219 567.169 -94.1609 799.642 137.139V276.079H-6.52344V173.529Z"
          fill="#F2F2F2"
        />
      </g>
      <rect :class="{ animate: !hasNoData }" x="310" y="68" width="68" height="35" rx="3" fill="#E0E0E0" />
      <rect :class="{ animate: !hasNoData }" x="310" y="118" width="68" height="35" rx="3" fill="#E0E0E0" />
      <rect :class="{ animate: !hasNoData }" x="386" y="78" width="35" height="16" rx="3" fill="#E0E0E0" />
      <rect :class="{ animate: !hasNoData }" x="386" y="128" width="35" height="16" rx="3" fill="#E0E0E0" />
      <rect :class="{ animate: !hasNoData }" x="40" y="78" width="262" height="16" rx="3" fill="#E0E0E0" />
      <rect :class="{ animate: !hasNoData }" x="40" y="128" width="262" height="16" rx="3" fill="#E0E0E0" />
    </svg>
  </div>
  <!-- No Data Found -->
  <div
    class="review-replies stretch-height"
    :style="`background: url(${getImageUrl('/social/repliesToReviewsBackground.svg')})`"
    v-else
  >
    <div class="visual-title">Replies to Reviews {{ dateFilterDisplayValue }}</div>
    <div class="review-replies-box">
      <div class="reply-section">
        <span class="reply-section-title">Percentage of replied reviews:</span>
        <span class="social-box">-</span>
      </div>
      <div class="reply-section">
        <span class="reply-section-title">Average response time:</span>
        <span class="social-box">-</span>
      </div>
    </div>
  </div>
</template>
